<script>
import { mapState, mapActions } from 'vuex';
import ModalOverlay from '@/components/modal/ModalOverlay';
import Simplebar from 'simplebar-vue';
import { bonusBoardHead } from '@/scripts/constants/map';

export default {
  name: 'ModalBonus',
  components: {
    ModalOverlay,
    Simplebar,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['userData', 'tiers']),
  },
  created() {
    this.bonusBoardHead = bonusBoardHead;
  },
  mounted() {},
  methods: {
    ...mapActions(['toggleModalBonus']),
  },
};
</script>

<template>
  <div>
    <ModalOverlay>
      <div class="modal__dialog">
        <div class="modal__content">
          <div class="modal__top">
            <div class="modal__title">Multiply Your Balance</div>
            <div class="modal__text">
              Your Bonus Multiplier is determined by the amount of RUSH tokens
              you hold in your PlayerRush account. The more tokens you hold, the
              larger your multiplier and the more RUSH tokens you earn as you
              play the games you love!
            </div>
            <div class="modal__close" @click="toggleModalBonus()">
              <img :src="require('@/assets/svg/close.svg')" />
            </div>
          </div>
          <div class="modal__middle">
            <Simplebar data-simplebar-auto-hide="false" class="scroll">
              <div class="modal__wrapper">
                <div class="modal__left">
                  <div class="table-title">Bonus Tiers</div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th
                          v-for="{ field, caption, width } in bonusBoardHead"
                          :key="field"
                          :style="[{ width: width + '%' }]"
                        >
                          {{ caption }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- map -->
                      <tr
                        v-for="(data, index) in tiers"
                        :key="index"
                        class="row"
                      >
                        <td
                          v-for="({ field }, index) in bonusBoardHead"
                          :key="index"
                        >
                          <div :class="['data', 'data--' + field]">
                            <span
                              >{{ data[field] }}
                              <span
                                class="data__type"
                                v-if="field === 'balance'"
                                >RUSH</span
                              >
                            </span>
                          </div>
                        </td>
                      </tr>
                      <!-- // -->
                    </tbody>
                  </table>
                </div>
                <div class="modal__right">
                  <div class="card">
                    <div class="card__content">
                      <!-- TODO: next release -->
                      <!-- <div class="card__title">Deposit Now!</div> -->
                      <div class="card__subtitle">Your RUSH Wallet</div>
                      <div class="card__text">
                        Send RUSH tokens to this wallet address to raise your
                        Bonus Tier and increase your Bonus Multiplier
                      </div>
                      <div class="card__value">
                        <div class="card__label">Current Balance</div>
                        <div class="card__balance">
                          {{ userData.currentBalance }}
                        </div>
                      </div>
                      <!-- TODO: -->
                      <!-- <div class="card__value">
                        <div class="card__label">Wallet</div>
                        <div class="card__wallet">
                          asdbnambqqnmnnndqkndadnamdn
                        </div>
                      </div> -->
                      <!-- TODO: next release -->
                      <!-- <div class="card__copy">
                        <button class="copy-wallet">
                          Copy wallet address
                        </button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </Simplebar>
          </div>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 50px 20px 40px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    max-width: 970px;
    max-height: 100%;
    border-radius: 36px;
    background-color: #101112;
    padding: 0 0 30px;
    display: flex;
    flex-direction: column;
    width: 100%;

    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 23px;
    color: #ffffff;
  }

  &__top {
    text-align: center;
    position: relative;
    padding: 40px 30px;
    flex-shrink: 0;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    margin-bottom: 14px;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    max-width: 712px;
    margin: 0 auto;
    width: 100%;
  }

  &__middle {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    padding: 20px 15px 0 30px;

    .scroll {
      flex-grow: 1;
    }
  }

  &__bottom {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    border-top: solid 1px #979797;
    padding: 30px 30px 0;
    margin-top: 10px;
  }

  &__close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }

  &__wrapper {
    padding: 0 55px 0 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__right {
    width: 355px;
    flex-shrink: 0;
    margin-left: 30px;
  }

  &__left {
    flex-grow: 1;
  }
}

.card {
  position: relative;
  padding: 30px 25px 40px;
  text-align: center;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    border-radius: 12px;
    background-image: linear-gradient(80deg, #232e33 7%, #172931 93%);
  }

  &__content {
    position: relative;
    z-index: 1;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
    margin-bottom: 25px;
  }

  &__subtitle {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #00c1fe;
    margin-bottom: 10px;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);

    & + .card__value {
      margin-top: 35px;
    }
  }

  &__value {
    & + & {
      margin-top: 15px;
    }
  }

  &__label {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 10px;
  }

  &__wallet {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  &__balance {
    font-family: Poppins-Regular;
    font-size: 27px;
    line-height: 37px;
    vertical-align: bottom;
    color: #ffc107;

    span {
      font-size: 21px;
    }
  }

  &__copy {
    display: none;
    margin-top: 20px;
    width: 100%;
    justify-content: center;
  }
}

.table-title {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: #00c1fe;
  margin-bottom: 10px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  thead {
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  }

  th {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    text-align: left;
    padding: 10px 15px;

    &:first-child {
      padding: 10px 0;
    }
  }

  .row {
    td {
      padding: 0;
    }
    td:first-child {
      .data {
        border-top-left-radius: 36px;
        border-bottom-left-radius: 36px;
      }
    }
    td:last-child {
      .data {
        border-top-right-radius: 36px;
        border-bottom-right-radius: 36px;
      }
    }

    &:first-child {
      .data {
        margin-top: 24px;
      }
    }
  }

  .data {
    height: 40px;
    background: #232e33;
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    letter-spacing: 0.29px;

    &--multiplier {
      font-family: Poppins-Light;
      font-size: 17px;
      line-height: 24px;
      letter-spacing: 0.35px;
      color: #ffd800;
      background: linear-gradient(
        90deg,
        rgba(22, 23, 24, 0.7) 0%,
        rgba(19, 20, 21, 1) 35%
      );
    }

    &--level {
      font-family: Poppins-SemiBold;
      background: linear-gradient(
        90deg,
        rgba(23, 24, 25, 1) 0%,
        rgba(22, 23, 24, 0.7) 35%
      );
    }

    &--balanceRequired {
      font-family: Poppins-Regular;
      background: linear-gradient(
        90deg,
        rgba(19, 20, 21, 0.7) 0%,
        rgba(17, 18, 19, 0.7) 35%
      );
    }

    &__type {
      font-size: 10px;
    }
  }
}

.copy-wallet {
  min-width: auto;
  border-radius: 8px;
  border: solid 1px rgba(255, 193, 7, 0.2);
  background-color: rgba(255, 193, 7, 0.1);
  position: relative;
  font-family: Poppins-Medium;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px 20px;
  width: 100%;
  max-width: 280px;
  min-height: 44px;
  color: #ffffff;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    width: 15px;
    height: 16px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url('~@/assets/svg/copy.svg');
  }
}

@media (max-width: $mobile) {
  .modal {
    &__dialog {
      align-items: flex-start;
      padding: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    &__content {
      padding: 0;
      border-radius: 0;
      background-color: #0b0b0b;
    }

    &__top {
      padding: 65px 15px 40px;
    }

    &__title {
      margin-bottom: 20px;
    }

    &__text {
      font-size: 12px;
      font-family: Poppins-Regular;
      line-height: 1.5;
      color: rgba(255, 255, 255, 0.8);
    }

    &__close {
      width: 18px;
      height: 18px;
      top: 18px;
      right: 18px;
    }

    &__middle {
      padding: 0;
      overflow: initial;
      background-color: #0b0b0b;
    }

    &__wrapper {
      padding: 0;
      flex-direction: column-reverse;
      width: 100%;
    }

    &__right {
      margin-left: 0;
      width: 100%;
    }

    &__left {
      width: 100%;
      padding: 40px 15px 35px;
    }
  }

  .card {
    padding: 30px 8px 30px;
    &:after {
      border-radius: 0;
      background-image: linear-gradient(76deg, #232e33 11%, #172931 89%);
    }

    &__wallet {
      word-break: break-all;
      font-size: 16px;
      padding: 0 30px;
      text-align: center;
      line-height: 1.5;
    }

    &__copy {
      display: flex;
    }
  }

  .table {
    th {
      padding: 10px 5px;
      width: auto !important;
      font-size: 11px;
      &:first-child {
        padding: 10px 5px;
      }
    }

    td:first-child {
      .data {
        padding: 5px 10px;
      }
    }

    .data {
      padding: 5px;
    }
  }
}
</style>
